import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const contentActions = [
  {
    title: 'Pages',
    href: '/dashboard/pages',
    description: 'Answer daily prompts in square tiles, with optional profile posting and friend filtering.',
    action: 'Open pages',
  },
  {
    title: 'Stories',
    href: '/dashboard/stories',
    description: 'Write chapters, memories, scenes, essays, and longer private or public life stories.',
    action: 'Open stories',
  },
  {
    title: 'Timeline',
    href: '/dashboard/timeline',
    description: 'Capture dated moments, seasons, turning points, and chronological context.',
    action: 'Open timeline',
  },
  {
    title: 'Profile Text Blocks',
    href: '/dashboard/site-theme',
    description: 'Use Site Theme to add markdown blocks that appear directly on the public profile.',
    action: 'Open site theme',
  },
];

function Content() {
  return (
    <>
      <SEO title="Content" />
      <section className="page-heading">
        <p className="eyebrow">Content hub</p>
        <h1>Write the pieces your profile can point to.</h1>
        <p>Stories and timeline entries stay focused here. Profile layout and visual placement stay in Site Theme.</p>
      </section>
      <section className="feature-grid hub-grid">
        {contentActions.map((item) => (
          <article className="surface-card" key={item.href}>
            <p className="tag">Content</p>
            <h2>{item.title}</h2>
            <p>{item.description}</p>
            <Link className="button button-secondary" to={item.href}>{item.action}</Link>
          </article>
        ))}
      </section>
    </>
  );
}

export default Content;
